import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDollarCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V4.31597C14.7395 4.6702 16.25 6.4087 16.25 8.5C16.25 8.91421 15.9142 9.25 15.5 9.25C15.0858 9.25 14.75 8.91421 14.75 8.5C14.75 7.24122 13.9043 6.17998 12.75 5.85352V11.316C14.7395 11.6702 16.25 13.4087 16.25 15.5C16.25 17.5913 14.7395 19.3298 12.75 19.684V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21V19.684C9.26049 19.3298 7.75 17.5913 7.75 15.5C7.75 15.0858 8.08579 14.75 8.5 14.75C8.91421 14.75 9.25 15.0858 9.25 15.5C9.25 16.7588 10.0957 17.82 11.25 18.1465V12.684C9.26049 12.3298 7.75 10.5913 7.75 8.5C7.75 6.4087 9.26049 4.6702 11.25 4.31597V3C11.25 2.58579 11.5858 2.25 12 2.25ZM11.25 5.85352C10.0957 6.17998 9.25 7.24122 9.25 8.5C9.25 9.75878 10.0957 10.82 11.25 11.1465V5.85352ZM12.75 12.8535V18.1465C13.9043 17.82 14.75 16.7588 14.75 15.5C14.75 14.2412 13.9043 13.18 12.75 12.8535Z",
		fill: "#98999A "
	})]
});
const ForwardRef = forwardRef(SvgDollarCircle);
export default ForwardRef;
